export const SUPPLY_DEMAND_SIGNAL_DETAIL_TYPES = {
  ENTRY: "supply_demand__entry",
  TP: "supply_demand__tp",
  SL: "supply_demand__sl",
  TRAILING_SL: "supply_demand__trailing_sl",
  SUPPLY_ZONE: "supply_demand__supply_zone"
};
